import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'react-emotion'

import Wrapper from 'components/Wrapper'
import NavBar from 'components/NavBar'
import Hero from 'components/Hero'
import Pricing from 'components/Pricing'
import Footer from 'components/Footer'
import { Dialog, InlineModal } from 'components/Modal'
import HowItWorks from 'components/HowItWorks'
import SignUp from 'components/SignUp'
import SiteMetadata from 'SiteMetadata'
import 'base-style'

const MainContainer = styled.div`
  position: relative;
`

const NavBarContainer = styled.div`
  left: 0;
  padding-top: 30px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 3;
`

class DefaultLayout extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    children: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      showInlineModal: false,
      showModal: false
    }

    this.goBack = this.goBack.bind(this)
  }

  componentDidMount() {
    this.toggleInlineModal(this.props.location)
    this.toggleModal(this.props.location)
  }

  componentWillReceiveProps(nextProps) {
    this.toggleInlineModal(nextProps.location)
    this.toggleModal(nextProps.location)
  }

  toggleInlineModal(location) {
    if (location.hash == '#how-it-works') {
      this.setState({ showInlineModal: true })
    } else {
      this.setState({ showInlineModal: false })
    }
  }

  toggleModal(location) {
    if (location.hash == '#sign-up') {
      this.setState({ showModal: true })
    } else {
      this.setState({ showModal: false })
    }
  }

  goBack() {
    const { history, location } = this.props

    if (history.length > 1) {
      history.goBack()
    } else {
      history.replace(location.pathname)
    }
  }

  render() {
    const children = this.props.children

    return (
      <div>
        <InlineModal
          isOpen={this.state.showInlineModal}
          closeHandler={this.goBack}
          onRequestClose={this.goBack}
          title="How it works">
          <HowItWorks />
        </InlineModal>
        <MainContainer>
          <Helmet
            title={`${SiteMetadata.title} - ${SiteMetadata.description}`}
            meta={[
              { name: 'description', content: SiteMetadata.description }
            ]}
          />
          <NavBarContainer>
            <Wrapper>
              <NavBar />
            </Wrapper>
          </NavBarContainer>
          {children()}
          <Footer />
        </MainContainer>
        <Dialog
          isOpen={this.state.showModal}
          closeHandler={this.goBack}
          onRequestClose={this.goBack}
          title="Learn More">
          <SignUp />
        </Dialog>
      </div>
    )
  }
}

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/layouts/index.js